import {Syllabary} from "./WordFetcher";
import {HistoryEvent} from "./HistoryEvent";

export class HistoryLoader {
    public static initRecentHistory(syllabary: Syllabary) {
        let recentHistory: HistoryEvent[] = [];
        let recentHistoryJSON;
        if (syllabary == Syllabary.hiragana) {
            recentHistoryJSON = localStorage.getItem('recentHiraganaHistory');
        } else {
            recentHistoryJSON = localStorage.getItem('recentKatakanaHistory');
        }
        if (recentHistoryJSON !== null) {
            recentHistory = JSON.parse(recentHistoryJSON);
        }
        return recentHistory;
    }
}


// WEBPACK FOOTER //
// ./src/HistoryLoader.ts